import { ref, computed, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function useModalRouting() {
  const route = useRoute()
  const router = useRouter()

  const modalCard = ref(null)

  const activeModal = computed(() => route.query.modal ?? null)

  function openModal(type, card = null) {
    modalCard.value = card
    const query = { ...route.query, modal: type }
    if (card?.id) query.modal_id = String(card.id)
    else delete query.modal_id
    router.push({ query })
  }

  function closeModal() {
    router.back()
  }

  watch(activeModal, (val) => {
    if (!val) modalCard.value = null
  })

  // Strip stale modal params on mount (e.g. from a pasted/bookmarked URL)
  onMounted(() => {
    if (route.query.modal) {
      const query = { ...route.query }
      delete query.modal
      delete query.modal_id
      router.replace({ query })
    }
  })

  return { activeModal, modalCard, openModal, closeModal }
}
